// Types
import { GetStream_stream } from 'api/streams/types/GetStream';
// Hooks
import { useStreamRecordsForDisplay } from 'hooks';
// Constants
import { SCHEDULE_STREAM } from 'constants/routes';
// Helpers
import { computeStreamAnalyticsPath } from 'helpers/routes';
// UI3
import LinkButton from 'ui3/LinkButton/LinkButton';
// Styles
import styles from './StreamOwnerActionButtons.module.scss';

type StreamOwnerActionButtonsProps = {
  stream: GetStream_stream;
};

const StreamOwnerActionButtons = ({
  stream,
}: StreamOwnerActionButtonsProps): JSX.Element => {
  const records = useStreamRecordsForDisplay(stream);
  const downloadLink = records?.[0]?.videoURL ?? '';

  return (
    <>
      <LinkButton
        variant="secondary"
        link={`${SCHEDULE_STREAM}/${stream.id}`}
        icon="pencil"
        size="medium"
        className={styles.borderedButton}
      >
        Edit
      </LinkButton>
      <LinkButton
        variant="secondary"
        link={downloadLink || ''}
        target="_blank"
        icon="download"
        iconSize={15}
        size="medium"
        className={styles.borderedButton}
      >
        Download
      </LinkButton>
      <LinkButton
        variant="secondary"
        link={computeStreamAnalyticsPath(stream.id)}
        icon="analytics"
        size="medium"
        aria-label="Event Analytics"
        className={styles.borderedButton}
      />
    </>
  );
};

export default StreamOwnerActionButtons;
